import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AddAcceptanceRequest, GetTermsAndConditionsRequest, SituViewWebApiClient, DocumentType, AddAcceptanceResponse } from 'situview-webapi-client';
import { AuthService, BreadcrumbService } from 'src/app/services';
import { ConfigService } from 'src/app/services/config.service';
import { EncodingService } from 'src/app/services/encoding-service';
import FingerprintJS from '@fingerprintjs/fingerprintjs';
import { Router } from '@angular/router';

@Component({
  selector: 'app-legal-agreement',
  templateUrl: './legal-agreement.component.html',
  styleUrls: ['./legal-agreement.component.scss']
})
export class LegalAgreementComponent implements OnInit {
  acceptLicenseAgreement: boolean = false;
  latestAgreementUrl: string | undefined;
  latestVersion: string | undefined;
  termsAndConditionsId: string | undefined;

  private _loading = false;
  public get loading(): boolean {
    return this._loading;
  }

  public set loading(val: boolean) {
    this._loading = val;
    this.breadcrumbService.setIsLoading(val);
  }

  constructor(private situViewWebApiClient: SituViewWebApiClient,
    private authService: AuthService,
    private snackBar: MatSnackBar,
    private breadcrumbService: BreadcrumbService,
    private configService: ConfigService,
    private router: Router) { }

  ngOnInit(): void {
    let request = new GetTermsAndConditionsRequest();
    request.documentType = DocumentType.License;
    request.ianaLanguageSubtag = "en";

    this.situViewWebApiClient.getTermsAndConditions(request).then(response => {
      this.latestAgreementUrl = response.documentLink ?? "";
      this.termsAndConditionsId = response.termsAndConditionsId;
      let lang = !!(response?.ianaLanguageSubtag) ? ` (${response.ianaLanguageSubtag})` : response.ianaLanguageSubtag ?? "";
      this.latestVersion = `v${response.major}.${response.minor}.${response.patch}${lang}`;
    }, error => {
      this.snackBar.open(`Unable to load Legal Agreement.`, 'OK', { duration: 2000 });
    })
  }

  setAcceptLicenseAgreement(value: boolean) {
    this.acceptLicenseAgreement = value;
  }

  continueClick() {
    let request = new AddAcceptanceRequest()
    request.companyId = this.authService.getDefaultCompanyId() ?? "";
    request.resourceId = this.authService.getDefaultCompanyId() ?? "";
    request.termsAndCondtionsId = this.termsAndConditionsId ?? "";
    this.loading = true;
    this.addAcceptance(request).then((response) => {
        if (response.success) {
            this.snackBar.open(`Legal Agreement has been marked as accepted.`, 'OK', { duration: 2000 });
            this.router.navigate(['/']);
        } else {
            this.snackBar.open(`An error occured whilst attempting to accept Legal Agreement.`, 'OK', { duration: 2000 });
        }
        this.loading = false;
    }, error => {
      this.snackBar.open(`An error occured whilst attempting to accept Legal Agreement.`, 'OK', { duration: 2000 });
      this.loading = false;
    });
  }

  private async addAcceptance(request: AddAcceptanceRequest): Promise<AddAcceptanceResponse> {
    let visitorId = await this.getVisitorId();
    let userDetails = this.getUserDetails(visitorId);
    var url = new URL(this.configService.config.situViewWebApiBaseUrl);
    url.pathname = "api/commands/addacceptance";

    return fetch(url.toString(), {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'AcceptanceHeaderInfo': `${EncodingService.encode(userDetails)}`,
            'Authorization': this.authService.getAuthorizationHeaderValue()
        },
        body: JSON.stringify(request),
    })
    .then(res =>  res.json())
    .then(json => json as AddAcceptanceResponse);
  }

  private getUserDetails(visitorId: string) {
    const offset = new Date().getTimezoneOffset();
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    let userDetails = {
      RemoteIpAddress: "",
      UserId: this.authService.getUserId(),
      VisitorId: visitorId,
      TimeZoneOffset: offset,
      TimeZone: timezone,
    };
    return userDetails;
  }

  private async getVisitorId() {
    let visitorId: string | undefined;

    const fp = await FingerprintJS.load();
    const result = await fp.get();
    visitorId = result.visitorId;

    return visitorId;
  }
}
